function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import * as S from './InputBase.styles';

/**
 * @deprecated Use string literals instead: 'large' or 'medium'.
 */
export let InputSize = /*#__PURE__*/function (InputSize) {
  InputSize["LARGE"] = "large";
  InputSize["MEDIUM"] = "medium";
  return InputSize;
}({});
const InputBase = /*#__PURE__*/React.forwardRef(({
  hasError,
  id,
  inputState,
  type,
  size,
  forceLeftAlignment,
  ...baseProps
}, ref) => {
  return /*#__PURE__*/React.createElement(S.InputRoot, _extends({
    id: id,
    ref: ref,
    type: type,
    "aria-invalid": hasError,
    $state: inputState,
    $type: type,
    $size: size,
    $forceLeftAlignment: forceLeftAlignment
  }, baseProps));
});
export { InputBase };